// third-party
import { createSlice } from '@reduxjs/toolkit';
// import { dispatch } from 'store';


// project imports
import axios from 'utils/axios';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    cities: [],
    cityTax: {},
    roomTypes: {},
    gptinstructions: {},
    activeMessages: [],
    interfaceStatus: {
        disabled: false,
        excludedEmails: [],
        loaded: false
    }
};

const slice = createSlice({
    name: 'settingsControl',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        getTaxCitiesSuccess(state, action) {
            state.cities = action.payload;
        },

        getCityTaxSuccess(state, action) {
            state.cityTax = action.payload;
        },

        getRoomTypesSuccess(state, action) {
            state.roomTypes = action.payload;
        },

        getGptInstructionsSuccess(state, action) {
            state.gptinstructions = action.payload;
        },

        getActiveMessagesSuccess(state, action) {
            state.activeMessages = action.payload;
        },

        getInterfaceStatusSuccess(state, action) {
            state.interfaceStatus = {
                disabled: !!action.payload.disabled,
                excludedEmails: Array.isArray(action.payload.excludedEmails)
                    ? action.payload.excludedEmails
                    : [],
                loaded: true
            };
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getTaxCities() {
    return async (dispatch) => {
        try {
            const response = await axios.get('/api/settings/tourism-tax/cities');
            dispatch(slice.actions.getTaxCitiesSuccess(response.data.cities));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export const createTaxLines = (taxes) => {
    return async (dispatch) => {
        try {
            const response = await axios.post('/api/settings/tourism-tax', taxes);
            if(response.date.suyccess) {
                return true;
            } else {
                dispatch(slice.actions.hasError(response.data.error));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    }
};

export function getCityTax(city) {
    return async (dispatch) => {
        try {
            const response = await axios.get(`/api/settings/tourism-tax/${city}`);
            dispatch(slice.actions.getCityTaxSuccess(response.data.taxes));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getRoomTypes() {
    return async (dispatch) => {
        try {
            const response = await axios.get('/api/rooms/types');
            dispatch(slice.actions.getRoomTypesSuccess(response.data.types));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getGptInstructions() {
    return async (dispatch) => {
        try {
            const response = await axios.get('/api/settings/gpt/instructions');
            dispatch(slice.actions.getGptInstructionsSuccess(response.data.instructions));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export const saveGptInstructions = (instructions) => {
    return async (dispatch) => {
        try {
            const response = await axios.post('/api/settings/gpt/instructions', { instructions });
            if(response.data.success) {
                dispatch(slice.actions.getGptInstructionsSuccess(instructions));
            } else {
                dispatch(slice.actions.hasError(response.data.error));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function getActiveMessages() {
    return async (dispatch) => {
        try {
            const response = await axios.get('/api/settings/gpt/active-messages');
            const messages = response.data.activeMessages || [];
            dispatch(slice.actions.getActiveMessagesSuccess(messages));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export const saveActiveMessages = (activeMessages) => {
    return async (dispatch) => {
        try {
            const response = await axios.post('/api/settings/gpt/active-messages', { activeMessages });
            if(response.data.success) {
                dispatch(slice.actions.getActiveMessagesSuccess(activeMessages));
                return true;
            } else {
                dispatch(slice.actions.hasError(response.data.error));
                return false;
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return false;
        }
    }
}

export function fetchInterfaceStatus() {
    return async (dispatch) => {
        try {
            const response = await axios.get('/api/settings/interface-status');
            dispatch(slice.actions.getInterfaceStatusSuccess({
                disabled: response.data.disabled,
                excludedEmails: response.data.excludedEmails
            }));
        } catch (error) {
            // Fail-open: never bloquer l'app sur une erreur réseau
            dispatch(slice.actions.getInterfaceStatusSuccess({
                disabled: false,
                excludedEmails: []
            }));
        }
    };
}

export const saveInterfaceStatus = ({ disabled, excludedEmails }) => {
    return async (dispatch) => {
        try {
            const response = await axios.post('/api/settings/interface-status', {
                disabled,
                excludedEmails
            });
            if (response.data.success) {
                dispatch(slice.actions.getInterfaceStatusSuccess({
                    disabled: response.data.disabled,
                    excludedEmails: response.data.excludedEmails
                }));
                return true;
            }
            dispatch(slice.actions.hasError(response.data.message));
            return false;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return false;
        }
    };
};